export const LOCALES = {
  UA: 'uk',
  RU: 'ru',
  EN: 'en',
  RO: 'ro',
};

export const MESSAGE_KEYS = {
  ERROR_PAGE_UNEXPECTED_BIG_HEADER: 'ERROR_PAGE_UNEXPECTED_BIG_HEADER',
  ERROR_PAGE_UNEXPECTED_MESSAGE: 'ERROR_PAGE_UNEXPECTED_MESSAGE',
  ERROR_PAGE_UNEXPECTED_BUTTON_MESSAGE: 'ERROR_PAGE_UNEXPECTED_BUTTON_MESSAGE',

  ERROR_PAGE_500_BIG_HEADER: 'ERROR_PAGE_500_BIG_HEADER',
  ERROR_PAGE_500_MESSAGE: 'ERROR_PAGE_500_MESSAGE',
  ERROR_PAGE_500_BUTTON_MESSAGE: 'ERROR_PAGE_500_BUTTON_MESSAGE',

  ERROR_MODAL_UNEXPECTED_MESSAGE: 'ERROR_MODAL_UNEXPECTED_MESSAGE',
};

const localesMessages = {
  [LOCALES.UA]: {
    [MESSAGE_KEYS.ERROR_PAGE_UNEXPECTED_BIG_HEADER]: 'Щось пішло не так',
    [MESSAGE_KEYS.ERROR_PAGE_UNEXPECTED_MESSAGE]: 'Ми вже працюємо над вирішенням цієї проблеми. Спробуйте перезавантажити сторінку або зайдіть пізніше.',
    [MESSAGE_KEYS.ERROR_PAGE_UNEXPECTED_BUTTON_MESSAGE]: 'Напишіть нам',

    [MESSAGE_KEYS.ERROR_PAGE_500_BIG_HEADER]: 'Упс, помилка серверу',
    [MESSAGE_KEYS.ERROR_PAGE_500_MESSAGE]: 'Ми вже працюємо над вирішенням цієї проблеми.',
    [MESSAGE_KEYS.ERROR_PAGE_500_BUTTON_MESSAGE]: 'На головну',

    [MESSAGE_KEYS.ERROR_MODAL_UNEXPECTED_MESSAGE]: 'Ми вже працюємо над вирішенням цієї проблеми.',
  },
  [LOCALES.RU]: {
    [MESSAGE_KEYS.ERROR_PAGE_UNEXPECTED_BIG_HEADER]: 'Что-то пошло не так',
    [MESSAGE_KEYS.ERROR_PAGE_UNEXPECTED_MESSAGE]: 'Мы уже работаем над решением этой проблемы. Попробуйте перезагрузить страницу или зайдите позже.',
    [MESSAGE_KEYS.ERROR_PAGE_UNEXPECTED_BUTTON_MESSAGE]: 'Напишите нам',

    [MESSAGE_KEYS.ERROR_PAGE_500_BIG_HEADER]: 'Упс, ошибка сервера',
    [MESSAGE_KEYS.ERROR_PAGE_500_MESSAGE]: 'Мы уже работаем над решением этой проблемы.',
    [MESSAGE_KEYS.ERROR_PAGE_500_BUTTON_MESSAGE]: 'На главную',

    [MESSAGE_KEYS.ERROR_MODAL_UNEXPECTED_MESSAGE]: 'Мы уже работаем над решением этой проблемы.',
  },
  [LOCALES.EN]: {
    [MESSAGE_KEYS.ERROR_PAGE_UNEXPECTED_BIG_HEADER]: 'Something went wrong',
    [MESSAGE_KEYS.ERROR_PAGE_UNEXPECTED_MESSAGE]: 'We are already working on this problem. Please, reload the page or try again later.',
    [MESSAGE_KEYS.ERROR_PAGE_UNEXPECTED_BUTTON_MESSAGE]: 'Contact us',

    [MESSAGE_KEYS.ERROR_PAGE_500_BIG_HEADER]: 'Oops, server error',
    [MESSAGE_KEYS.ERROR_PAGE_500_MESSAGE]: 'We are already working on this problem.',
    [MESSAGE_KEYS.ERROR_PAGE_500_BUTTON_MESSAGE]: 'Go to homepage',

    [MESSAGE_KEYS.ERROR_MODAL_UNEXPECTED_MESSAGE]: 'We are already working on a solution to this problem.',
  },
  [LOCALES.RO]: {
    [MESSAGE_KEYS.ERROR_PAGE_UNEXPECTED_BIG_HEADER]: 'Ceva nu a mers',
    [MESSAGE_KEYS.ERROR_PAGE_UNEXPECTED_MESSAGE]: 'Lucrăm deja soluţionarea acestei probleme. Încercați să reîncărcați pagina sau reveniți mai târziu.',
    [MESSAGE_KEYS.ERROR_PAGE_UNEXPECTED_BUTTON_MESSAGE]: 'Scrieți-ne',

    [MESSAGE_KEYS.ERROR_PAGE_500_BIG_HEADER]: 'Oops, eroare de server',
    [MESSAGE_KEYS.ERROR_PAGE_500_MESSAGE]: 'Lucrăm deja soluţionarea acestei probleme.',
    [MESSAGE_KEYS.ERROR_PAGE_500_BUTTON_MESSAGE]: 'Du-te la pagina principală',

    [MESSAGE_KEYS.ERROR_MODAL_UNEXPECTED_MESSAGE]: 'Lucrăm deja la soluționarea acestei probleme.',
  },
};

/**
 * Return localized message.
 * @param {string} locale - current locale like (ru, uk, en)
 * @param {string} messageKey - constant of MESSAGE_KEYS
 */
export function getMessage(locale: string, messageKey: string) {
  const messages = localesMessages[locale] || localesMessages[LOCALES.EN];
  return messages[messageKey];
}
